import { defineStore } from 'pinia'
import Api from '@/config/api.helper'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    darkMode: false,
  }),

  getters: {
    isDark: (state) => state.darkMode,
  },

  actions: {
    setDarkMode(isDark: boolean) {
      this.darkMode = isDark

      localStorage.setItem('darkTheme', String(isDark))
      document.documentElement.classList.toggle('dark', isDark)
    },

    async toggleThemeWithPersistence(userId: string) {
      const newThemeState = !this.darkMode
      this.setDarkMode(newThemeState)

      try {
        const themeName = newThemeState ? 'escuro' : 'claro'
        const data = {
          usu_id: userId,
          chave: 'tema',
          valor: [themeName],
        }
        await Api.put('usuarios/usuario/configuracoes', data)
      } catch (error) {
        console.error('Falha ao salvar preferência de tema:', error)
        // this.setDarkMode(!newThemeState);
      }
    },

    initTheme() {
      const storedTheme = localStorage.getItem('darkTheme')
      this.setDarkMode(storedTheme === 'true')
    },
  },
})
